function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { memo, PureComponent, useCallback, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { GridUtils } from '@deephaven/grid';
import { TextUtils, assertNotNull, DbNameValidator } from '@deephaven/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dhEye, dhEyeSlash, dhSortAlphaDown, dhSortAlphaUp, dhArrowToTop, dhArrowToBottom, vsChevronUp, vsChevronDown, vsSymbolStructure, vsRefresh, vsCircleLargeFilled, vsAdd, vsBlank, vsCheck, vsKebabVertical } from '@deephaven/icons';
import memoize from 'memoizee';
import { ActionButton, Button, GLOBAL_SHORTCUTS, Icon, Item, Keyboard, MenuTrigger, Section, SpectrumMenu, Text } from '@deephaven/components';
import clamp from 'lodash.clamp';
import throttle from 'lodash.throttle';
import { useUndoRedo } from '@deephaven/react-hooks';
import Log from '@deephaven/log';
import "./VisibilityOrderingBuilder.css";
import ColumnHeaderGroup from "../../ColumnHeaderGroup.js";
import VisibilityOrderingItem from "./VisibilityOrderingItem.js";
import { flattenTree, getTreeItems } from "./sortable-tree/utilities.js";
import SortableTree from "./sortable-tree/SortableTree.js";
import { moveItemsFromDrop, moveToGroup } from "./VisibilityOrderingBuilderUtils.js";
import IrisGridUtils from "../../IrisGridUtils.js";
import SearchWithModal from "./SearchWithModal.js";
import SortableTreeDndContext from "./sortable-tree/SortableTreeDndContext.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('VisibilityOrderingBuilder');
class VisibilityOrderingBuilderInner extends PureComponent {
  static shouldRenderColumn(column) {
    // We don't want to render the proxy column in the visibility ordering list
    return column.isProxy !== true;
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "wrapperRef", /*#__PURE__*/React.createRef());
    /**
     * Used to track the last focused item index to maintain focus on updates.
     * Cannot use name because it may change or be deleted when undoing or redoing.
     */
    _defineProperty(this, "lastFocusedItemIndex", null);
    _defineProperty(this, "list", void 0);
    _defineProperty(this, "virtualizerRef", /*#__PURE__*/React.createRef());
    /**
     * This is set by the search modal handlers since a column could be hidden
     * and not displayed in the list. We need to wait until the update to scroll to it.
     */
    _defineProperty(this, "scrollAndFocusColumnOnUpdate", null);
    _defineProperty(this, "handleGroupColorChange", throttle((group, color) => {
      var _this$props = this.props,
        columnHeaderGroups = _this$props.columnHeaderGroups,
        onColumnHeaderGroupChanged = _this$props.onColumnHeaderGroupChanged;
      var newGroups = [...columnHeaderGroups];
      var newGroup = new ColumnHeaderGroup(_objectSpread(_objectSpread({}, group), {}, {
        color
      }));
      newGroups.splice(newGroups.findIndex(_ref => {
        var name = _ref.name;
        return name === group.name;
      }), 1, newGroup);
      onColumnHeaderGroupChanged(newGroups);
    }, 250));
    _defineProperty(this, "getMemoizedFirstMovableIndex", memoize((model, columns, movedColumns) => {
      for (var i = 0; i < columns.length; i += 1) {
        var modelIndex = GridUtils.getModelIndex(i, movedColumns);
        if (model.isColumnMovable(modelIndex)) {
          return i;
        }
      }
      return null;
    }, {
      max: 10
    }));
    _defineProperty(this, "getMemoizedLastMovableIndex", memoize((model, columns, movedColumns) => {
      for (var i = columns.length - 1; i >= 0; i -= 1) {
        var modelIndex = GridUtils.getModelIndex(i, movedColumns);
        if (model.isColumnMovable(modelIndex)) {
          return i;
        }
      }
      return null;
    }, {
      max: 10
    }));
    _defineProperty(this, "memoizedGetTreeItems", memoize((columns, movedColumns, columnHeaderGroups, hiddenColumns, selectedColumns, showHiddenColumns) => getTreeItems(columns, movedColumns, columnHeaderGroups, hiddenColumns, [...selectedColumns.values()], showHiddenColumns), {
      max: 2
    }));
    _defineProperty(this, "memoizedGetFlattenedTree", memoize(treeItems => flattenTree(treeItems), {
      max: 2
    }));
    _defineProperty(this, "makeVisibilityOrderingList", memoize((columns, treeItems, showHiddenColumns, isDraggable) => {
      var movedColumns = this.props.movedColumns;
      var elements = [];
      var firstMovableIndex = this.getFirstMovableIndex();
      var lastMovableIndex = this.getLastMovableIndex();
      var firstMovableTreeIndex = treeItems.findIndex(_ref2 => {
        var data = _ref2.data;
        return Array.isArray(data.visibleIndex) ? data.visibleIndex[0] === firstMovableIndex : data.visibleIndex === firstMovableIndex;
      });

      // Searches from the end so it's faster than findIndex
      var lastMovableTreeIndex = treeItems.findLastIndex(_ref3 => {
        var data = _ref3.data;
        return Array.isArray(data.visibleIndex) ? data.visibleIndex[1] === lastMovableIndex : data.visibleIndex === lastMovableIndex;
      });
      var movableItems = treeItems.slice(firstMovableTreeIndex, lastMovableTreeIndex + 1);
      if (!showHiddenColumns) {
        movableItems = movableItems.filter(item => item.data.isVisible);
      }

      // No movable items. Render all as immovable
      if (firstMovableIndex == null || lastMovableIndex === null) {
        for (var visibleIndex = 0; visibleIndex < columns.length; visibleIndex += 1) {
          var modelIndex = GridUtils.getModelIndex(visibleIndex, movedColumns);
          var column = columns[modelIndex];
          if (VisibilityOrderingBuilderInner.shouldRenderColumn(column)) {
            elements.push(this.renderImmovableItem(column.name));
          }
        }
        return elements;
      }

      // Currently immovable groups are not supported
      for (var _visibleIndex = 0; _visibleIndex < firstMovableIndex; _visibleIndex += 1) {
        var _modelIndex = GridUtils.getModelIndex(_visibleIndex, movedColumns);
        var _column = columns[_modelIndex];
        if (VisibilityOrderingBuilderInner.shouldRenderColumn(_column)) {
          elements.push(this.renderImmovableItem(_column.name));
        }
      }
      if (firstMovableIndex !== null && firstMovableIndex > 0) {
        elements.push(/*#__PURE__*/_jsx("hr", {}, "top-horizontal-divider"));
      }
      elements.push(/*#__PURE__*/_jsx(SortableTree, {
        items: movableItems,
        renderItem: this.renderItem,
        isDraggable: isDraggable,
        virtualizerRef: this.virtualizerRef
      }, "movable-items"));
      if (lastMovableIndex != null && lastMovableIndex < columns.length - 1) {
        elements.push(/*#__PURE__*/_jsx("hr", {}, "bottom-horizontal-divider"));
      }
      for (var _visibleIndex2 = lastMovableIndex + 1; _visibleIndex2 < columns.length; _visibleIndex2 += 1) {
        var _modelIndex2 = GridUtils.getModelIndex(_visibleIndex2, movedColumns);
        var _column2 = columns[_modelIndex2];
        if (VisibilityOrderingBuilderInner.shouldRenderColumn(_column2)) {
          elements.push(this.renderImmovableItem(_column2.name));
        }
      }
      return elements;
    }, {
      max: 10
    }));
    _defineProperty(this, "renderImmovableItem", memoize(columnName => /*#__PURE__*/_jsx("div", {
      className: "visibility-ordering-list-item immovable",
      children: /*#__PURE__*/_jsx("div", {
        className: "column-item",
        children: /*#__PURE__*/_jsx("span", {
          className: "column-name",
          children: columnName
        })
      })
    }, columnName), {
      max: 100
    }));
    this.handleItemClick = this.handleItemClick.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
    this.handleGroupDelete = this.handleGroupDelete.bind(this);
    this.handleGroupNameChange = this.handleGroupNameChange.bind(this);
    this.handleGroupCreate = this.handleGroupCreate.bind(this);
    this.validateGroupName = this.validateGroupName.bind(this);
    this.addColumnToSelected = this.addColumnToSelected.bind(this);
    this.handleDragStart = this.handleDragStart.bind(this);
    this.handleOverflowAction = this.handleOverflowAction.bind(this);
    this.handleKeyboardShortcut = this.handleKeyboardShortcut.bind(this);
    this.handleSearchModalOpenChange = this.handleSearchModalOpenChange.bind(this);
    this.handleSearchSelect = this.handleSearchSelect.bind(this);
    this.handleSearchItemClicked = this.handleSearchItemClicked.bind(this);
    this.renderItem = this.renderItem.bind(this);
    this.state = {
      selectedColumns: new Set(),
      lastSelectedColumn: '',
      showHiddenColumns: true,
      isSearchModalOpen: false,
      movedColumns: props.movedColumns,
      columnHeaderGroups: props.columnHeaderGroups
    };
    this.list = null;
  }
  componentDidMount() {
    assertNotNull(this.wrapperRef.current);
    // This fixes focus loss when editing a group because we use the name as the key for rendering.
    // When the name is changed or group deleted, we lose focus entirely which is indicated by
    // the focusout relatedTarget being null.
    this.wrapperRef.current.addEventListener('focusin', e => {
      if (e.target instanceof HTMLElement) {
        var treeItem = e.target.closest('.tree-item');
        if (treeItem != null) {
          this.lastFocusedItemIndex = typeof treeItem.dataset.index === 'string' ? parseInt(treeItem.dataset.index, 10) : null;
        }
      }
    });
  }
  componentDidUpdate(prevProps) {
    // If we change because of undo/redo or reorders in the grid, update internal state
    var _this$props2 = this.props,
      movedColumns = _this$props2.movedColumns,
      columnHeaderGroups = _this$props2.columnHeaderGroups;
    if (prevProps.movedColumns !== movedColumns) {
      this.setState({
        movedColumns
      });
    }
    if (prevProps.columnHeaderGroups !== columnHeaderGroups) {
      this.setState({
        columnHeaderGroups
      });
    }

    // Scroll to the item when it's available
    if (this.scrollAndFocusColumnOnUpdate != null) {
      var _this$virtualizerRef$;
      var _this$scrollAndFocusC = _slicedToArray(this.scrollAndFocusColumnOnUpdate, 2),
        itemIndex = _this$scrollAndFocusC[0],
        itemName = _this$scrollAndFocusC[1];
      (_this$virtualizerRef$ = this.virtualizerRef.current) === null || _this$virtualizerRef$ === void 0 || _this$virtualizerRef$.scrollToIndex(itemIndex);

      // Need to wait for the paint after the scroll so the item exists in the DOM
      window.requestAnimationFrame(() => {
        var _this$list;
        if (this.scrollAndFocusColumnOnUpdate == null) {
          return;
        }
        var itemElement = (_this$list = this.list) === null || _this$list === void 0 ? void 0 : _this$list.querySelector(".item-wrapper[data-id=\"".concat(itemName, "\"] .tree-item"));
        if (itemElement instanceof HTMLElement) {
          itemElement.focus();
        } else {
          log.warn("Could not focus item ".concat(itemName, " after scroll"));
        }
        this.scrollAndFocusColumnOnUpdate = null;
      });
    }

    // document.activeElement is either body or html when nothing is focused.
    // If there is no focused element, then we probably deleted or renamed a group
    // resulting in focus loss. Try to re-establish focus.
    // Cannot rely on focusout event for this because it doesn't fire when the focused element is deleted
    // (except in Chrome which is against the spec here).
    if ((document.activeElement === document.body || document.activeElement === document.documentElement) && this.lastFocusedItemIndex !== null) {
      var _this$list2;
      var itemToFocus = (_this$list2 = this.list) === null || _this$list2 === void 0 ? void 0 : _this$list2.querySelector(".item-wrapper[data-index=\"".concat(this.lastFocusedItemIndex, "\"] .tree-item"));
      if (itemToFocus != null && itemToFocus instanceof HTMLElement) {
        itemToFocus.focus();
      } else {
        log.warn('Could not maintain focus');
        this.lastFocusedItemIndex = null;
      }
    }
  }
  componentWillUnmount() {
    var _this$props3 = this.props,
      columnHeaderGroups = _this$props3.columnHeaderGroups,
      onColumnHeaderGroupChanged = _this$props3.onColumnHeaderGroupChanged;
    // Clean up unnamed groups on unmount
    var filteredGroups = columnHeaderGroups.filter(group => !group.isNew);
    if (filteredGroups.length !== columnHeaderGroups.length) {
      onColumnHeaderGroupChanged(filteredGroups);
    }
  }
  resetVisibilityOrdering() {
    var _this$props4 = this.props,
      model = _this$props4.model,
      onReset = _this$props4.onReset,
      onMovedColumnsChanged = _this$props4.onMovedColumnsChanged,
      onColumnHeaderGroupChanged = _this$props4.onColumnHeaderGroupChanged;
    this.setState({
      selectedColumns: new Set(),
      lastSelectedColumn: ''
    });
    onReset();
    onColumnHeaderGroupChanged(model.initialColumnHeaderGroups);
    onMovedColumnsChanged(model.initialMovedColumns);
  }
  resetSelection() {
    this.setState({
      selectedColumns: new Set(),
      lastSelectedColumn: ''
    });
  }

  /**
   * Moves the currently selected columns in the direction specified.
   * Does not commit any changes to any state, just gets the required modifications.
   *
   * Items that are part of a selected group should not be moved separate from the group.
   *
   * Items moved to top or bottom should be removed from any groups they are within,
   * unless part of a group that is also selected. The highest level selected group will
   * be moved to the root level of the tree.
   *
   * Items moved up or down should move into and out of groups when applicable.
   * They should never move more than 1 depth level at a time.
   *
   * Multiple selected items should move to the top or bottom in their existing order,
   * but become one block of continuous columns.
   *
   * Multiple selected items moving up or down should move independently,
   * unless they are at the same depth and contiguous. In that case, they should
   * move in and out of groups together. I.e. if the 2 items above a group are selected,
   * and the move down button is pressed, then both items should be moved into the group.
   *
   * @param option The movement option
   * @returns A new copy of the movedColumns including moves required to perform the operation.
   *
   */
  moveSelectedColumns(option) {
    var columnHeaderGroups = this.props.columnHeaderGroups;
    var selectedColumns = this.state.selectedColumns;
    var treeItems = this.getFlattenedTree();
    var firstMovableIndex = this.getFirstMovableIndex();
    var lastMovableIndex = this.getLastMovableIndex();
    assertNotNull(firstMovableIndex);
    assertNotNull(lastMovableIndex);
    var selectedItems = this.getSelectedParentItems();
    var isMovingUpward = option === VisibilityOrderingBuilderInner.MOVE_OPTIONS.UP || option === VisibilityOrderingBuilderInner.MOVE_OPTIONS.TOP;

    // for moving up and to the top, move column(s) in visibility index order
    // for moving down and to the bottom, move column(s) in reverse visibility index order
    if (!isMovingUpward) {
      selectedItems.reverse();
    }
    var newMoves = [];
    var updatedGroups = columnHeaderGroups;
    var _loop = function _loop() {
      var _selectedItems$i = selectedItems[i],
        id = _selectedItems$i.id,
        parentId = _selectedItems$i.parentId,
        depth = _selectedItems$i.depth,
        visibleIndex = _selectedItems$i.data.visibleIndex;
      switch (option) {
        case VisibilityOrderingBuilderInner.MOVE_OPTIONS.TOP:
          {
            newMoves = GridUtils.moveItemOrRange(visibleIndex, firstMovableIndex, newMoves, true);
            var size = Array.isArray(visibleIndex) ? visibleIndex[1] - visibleIndex[0] + 1 : 1;
            firstMovableIndex += size;
            // Moving items to top should move out of any groups
            updatedGroups = moveToGroup(selectedItems[i], null, updatedGroups);
            break;
          }
        case VisibilityOrderingBuilderInner.MOVE_OPTIONS.BOTTOM:
          {
            newMoves = GridUtils.moveItemOrRange(visibleIndex, lastMovableIndex, newMoves, true);
            var _size = Array.isArray(visibleIndex) ? visibleIndex[1] - visibleIndex[0] + 1 : 1;
            lastMovableIndex -= _size;
            // Moving items to bottom should move out of any groups
            updatedGroups = moveToGroup(selectedItems[i], null, updatedGroups);
            break;
          }
        case VisibilityOrderingBuilderInner.MOVE_OPTIONS.UP:
          {
            var itemIndex = treeItems.findIndex(item => item.id === id);
            // Array.findLast would be better here, but it's too new for our browser support
            var prevItemIndex = treeItems.map((item, idx) => idx < itemIndex && !selectedColumns.has(item.id)).lastIndexOf(true);
            var prevItem = treeItems[prevItemIndex];
            if (prevItem != null && prevItem.parentId !== parentId) {
              // Moving into a different parent
              if (Math.abs(prevItem.depth - depth) > 1) {
                // Prev item is more than 1 level away
                // Find prev parent at same depth as current
                // This way we only ever move 1 depth level per event
                var newParentItemIndex = treeItems.map((item, idx) => idx < prevItemIndex && item.depth === depth).lastIndexOf(true);
                var newParentItem = treeItems[newParentItemIndex];
                updatedGroups = moveToGroup(selectedItems[i], newParentItem.id, updatedGroups);
              } else {
                updatedGroups = moveToGroup(selectedItems[i], prevItem.parentId, updatedGroups);
              }
            } else {
              var toIndex = clamp(Array.isArray(visibleIndex) ? visibleIndex[0] - 1 : visibleIndex - 1, firstMovableIndex, lastMovableIndex);
              newMoves = GridUtils.moveItemOrRange(visibleIndex, toIndex, newMoves, false);
              var _size2 = Array.isArray(visibleIndex) ? visibleIndex[1] - visibleIndex[0] + 1 : 1;
              firstMovableIndex += _size2;
            }
            break;
          }
        case VisibilityOrderingBuilderInner.MOVE_OPTIONS.DOWN:
          {
            var _itemIndex = treeItems.findIndex(item => item.id === id);
            var nextItem = treeItems.find((item, idx) => idx > _itemIndex && !selectedColumns.has(item.id));
            if ((nextItem === null || nextItem === void 0 ? void 0 : nextItem.parentId) !== parentId) {
              var _parentItem$parentId;
              // Moving out of our group
              // Move to the parent of our parent
              // That way we only ever move 1 level at a time
              var parentItem = treeItems.find(item => item.id === parentId);
              updatedGroups = moveToGroup(selectedItems[i], (_parentItem$parentId = parentItem === null || parentItem === void 0 ? void 0 : parentItem.parentId) !== null && _parentItem$parentId !== void 0 ? _parentItem$parentId : null, updatedGroups);
              break;
            } else if ((nextItem === null || nextItem === void 0 ? void 0 : nextItem.children.length) > 0) {
              // Moving into a group as 1st item
              updatedGroups = moveToGroup(selectedItems[i], nextItem.id, updatedGroups);
              break;
            }
            var _toIndex = clamp(Array.isArray(visibleIndex) ? visibleIndex[0] + 1 : visibleIndex + 1, firstMovableIndex, lastMovableIndex);
            newMoves = GridUtils.moveItemOrRange(visibleIndex, _toIndex, newMoves, false);
            var _size3 = Array.isArray(visibleIndex) ? visibleIndex[1] - visibleIndex[0] + 1 : 1;
            lastMovableIndex -= _size3;
            break;
          }
      }
    };
    for (var i = 0; i < selectedItems.length; i += 1) {
      _loop();
    }
    return {
      newMoves,
      groups: updatedGroups
    };
  }

  /**
   * Moves the selected columns according to the option.
   * Commits changes to state and scrolls the list if moving to top or bottom.
   *
   * @param option The move operation
   */
  handleMoveColumns(option) {
    var _this$props5 = this.props,
      onMovedColumnsChanged = _this$props5.onMovedColumnsChanged,
      movedColumns = _this$props5.movedColumns,
      onColumnHeaderGroupChanged = _this$props5.onColumnHeaderGroupChanged;
    var _this$moveSelectedCol = this.moveSelectedColumns(option),
      newMoves = _this$moveSelectedCol.newMoves,
      groups = _this$moveSelectedCol.groups;
    var scrollListAfterMove;
    if (option === VisibilityOrderingBuilderInner.MOVE_OPTIONS.TOP) {
      scrollListAfterMove = () => {
        var _this$virtualizerRef$2;
        (_this$virtualizerRef$2 = this.virtualizerRef.current) === null || _this$virtualizerRef$2 === void 0 || _this$virtualizerRef$2.scrollToOffset(0);
      };
    }
    if (option === VisibilityOrderingBuilderInner.MOVE_OPTIONS.BOTTOM) {
      scrollListAfterMove = () => {
        var _this$virtualizerRef$3;
        (_this$virtualizerRef$3 = this.virtualizerRef.current) === null || _this$virtualizerRef$3 === void 0 || _this$virtualizerRef$3.scrollBy(this.virtualizerRef.current.getTotalSize());
      };
    }
    onColumnHeaderGroupChanged(groups);
    if (newMoves.length > 0) {
      onMovedColumnsChanged(movedColumns.concat(newMoves), scrollListAfterMove);
    }
  }

  /**
   * Get the move operations required to recursively sort the grid
   * Column header groups are sorted using their name
   * Children of column header groups are then sorted within each group
   *
   * @param items The tree items to sort
   * @param option Direction of the sort
   * @param movedColumns The existing moved columns for the sort
   *                     Grids may use an initial move list from the model (e.g. column header groups)
   *                     Also used to recursively sort header groups
   * @returns The moves required to sort the grid. Includes the starting movedColumns in the array
   */
  getSortMoves(itemsParam, option, movedColumns) {
    var items = [...itemsParam];
    // Sort all the movable columns
    var isAscending = option === VisibilityOrderingBuilderInner.SORTING_OPTIONS.ASC;
    items.sort((a, b) => {
      var aName = a.id.toUpperCase();
      var bName = b.id.toUpperCase();
      return TextUtils.sort(aName, bName, isAscending);
    });
    var newMoves = [...movedColumns]; // Start with the base state moves by the model
    var moveToIndex = Math.min(...items.flatMap(item => {
      var modelIndex = item.data.modelIndex;
      return Array.isArray(modelIndex) ? GridUtils.getVisibleIndexes(modelIndex, newMoves) : GridUtils.getVisibleIndex(modelIndex, newMoves);
    }));
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      var modelIndex = item.data.modelIndex;
      var visibleIndex = Array.isArray(modelIndex) ? GridUtils.getVisibleIndexes(modelIndex, newMoves) : GridUtils.getVisibleIndex(modelIndex, newMoves);
      newMoves = Array.isArray(visibleIndex) ? GridUtils.moveRange([Math.min(...visibleIndex), Math.max(...visibleIndex)], moveToIndex, newMoves, true) : GridUtils.moveItem(visibleIndex, moveToIndex, newMoves);
      if (Array.isArray(visibleIndex)) {
        // Recursively sort groups
        newMoves = this.getSortMoves(item.children, option, newMoves);
      }
      moveToIndex += Array.isArray(modelIndex) ? modelIndex.length : 1;
    }
    return newMoves;
  }
  handleSortColumns(option) {
    var _this$getFirstMovable, _this$getLastMovableI;
    var _this$props6 = this.props,
      model = _this$props6.model,
      onMovedColumnsChanged = _this$props6.onMovedColumnsChanged;
    var tree = this.getTreeItems();
    var firstIndex = (_this$getFirstMovable = this.getFirstMovableIndex()) !== null && _this$getFirstMovable !== void 0 ? _this$getFirstMovable : 0;
    var lastIndex = (_this$getLastMovableI = this.getLastMovableIndex()) !== null && _this$getLastMovableI !== void 0 ? _this$getLastMovableI : tree.length - 1;
    var moveableTree = tree.slice(firstIndex, lastIndex + 1);

    // add frozen moves
    var initialAndFrozenMovedColumns = [...model.initialMovedColumns];
    for (var i = 0; i < model.frozenColumns.length; i += 1) {
      var _model$getColumnIndex;
      var frozenColumn = model.frozenColumns[i];
      var newFrozenIndex = GridUtils.getVisibleIndex((_model$getColumnIndex = model.getColumnIndexByName(frozenColumn)) !== null && _model$getColumnIndex !== void 0 ? _model$getColumnIndex : 0, initialAndFrozenMovedColumns);
      if (newFrozenIndex !== i) {
        initialAndFrozenMovedColumns.push({
          from: newFrozenIndex,
          to: i
        });
      }
    }
    var newMoves = this.getSortMoves(moveableTree, option, initialAndFrozenMovedColumns);
    onMovedColumnsChanged(newMoves);
  }

  /**
   * Handles clicking on an item in the visibility ordering list.
   * Adds and removes to selection as necessary based on modifier and shift keys.
   * Returns the columns to be added to the selection, if any.
   *
   * @param name The name of the column clicked
   * @param event The click event
   * @param showHiddenColumns If hidden columns should be included in the selection
   * @returns The columns to be added to the selection, if any`
   */
  handleItemClick(name, event) {
    var _event$currentTarget;
    var showHiddenColumns = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    event.stopPropagation();

    // Click was triggered by an interactive element. Ignore select
    if (event.target instanceof HTMLElement && (event.target.tagName === 'BUTTON' || event.target.tagName === 'INPUT')) {
      return [];
    }
    (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || _event$currentTarget.focus();
    var _this$state = this.state,
      selectedColumns = _this$state.selectedColumns,
      lastSelectedColumn = _this$state.lastSelectedColumn;
    var isModifierKeyDown = GridUtils.isModifierKeyDown(event);
    var isShiftKeyDown = event.shiftKey;
    var isSelected = selectedColumns.has(name);
    var columnsToBeAdded = [name];
    if (isSelected && isModifierKeyDown) {
      this.removeColumnFromSelected(name);
      return [];
    }
    var movableItems = this.getFlattenedTree(showHiddenColumns);
    if (isSelected && !isShiftKeyDown && lastSelectedColumn === name) {
      var selectedItem = movableItems.find(_ref4 => {
        var id = _ref4.id;
        return id === name;
      });
      assertNotNull(selectedItem);
      var childCount = flattenTree(selectedItem.children).length;
      // If clicking on an item and it's the only thing selected, deselect it
      if (childCount + 1 === selectedColumns.size) {
        this.resetSelection();
        return [];
      }
    }
    if (isShiftKeyDown) {
      var selectedIndex = movableItems.findIndex(item => item.id === name);
      var lastSelectedIndex = movableItems.findIndex(item => item.id === lastSelectedColumn);
      columnsToBeAdded.push(...movableItems.slice(Math.min(lastSelectedIndex, selectedIndex), Math.max(lastSelectedIndex, selectedIndex) + 1).map(item => item.id));
    }
    this.addColumnToSelected(columnsToBeAdded, isModifierKeyDown || isShiftKeyDown);
    this.setState({
      lastSelectedColumn: name
    });
    return columnsToBeAdded;
  }
  handleSearchItemClicked(item, event) {
    var columnsToAdd = this.handleItemClick(item.id, event, true);
    var showHiddenColumns = this.state.showHiddenColumns;
    var onColumnVisibilityChanged = this.props.onColumnVisibilityChanged;
    if (columnsToAdd.length === 0) {
      return;
    }
    var modelIndexesToShow = this.getSelectedItemModelIndexes(new Set(columnsToAdd));
    if (!showHiddenColumns) {
      onColumnVisibilityChanged(modelIndexesToShow, true);
    }
    if (event.shiftKey || GridUtils.isModifierKeyDown(event)) {
      return;
    }
    this.scrollAndFocusColumnOnUpdate = [item.index, item.id];
  }
  handleSearchSelect(items) {
    if (items.length === 0) {
      return;
    }
    var showHiddenColumns = this.state.showHiddenColumns;
    var onColumnVisibilityChanged = this.props.onColumnVisibilityChanged;
    if (!showHiddenColumns) {
      var modelIndexesToShow = [...new Set(items.map(item => item.data.modelIndex).flat())];
      onColumnVisibilityChanged(modelIndexesToShow, true);
    }
    this.scrollAndFocusColumnOnUpdate = [items[0].index, items[0].id];
    this.addColumnToSelected(items.map(item => item.id), false);
  }

  /**
   * Adds columns or groups to the selected column set
   * Groups being added will add all of their children to the selection as well
   *
   * @param columnsToBeAdded Array of column or group names to add
   * @param addToExisting If these should be added to the existing selection or overwrite it
   */
  addColumnToSelected(columnsToBeAdded, addToExisting) {
    var selectedColumns = this.state.selectedColumns;
    var newSelectedColumns = new Set(addToExisting ? [...selectedColumns.values()].concat(columnsToBeAdded) : columnsToBeAdded);
    var flattenedItems = this.getFlattenedTree();

    // Add all children of selected groups to the selected columns
    // The treeItems array will always be parent -> child in the order
    // We don't need to recursively iterate because of this
    // The parent will always be added before any children for nested selections
    flattenedItems.forEach(_ref5 => {
      var id = _ref5.id,
        children = _ref5.children;
      if (newSelectedColumns.has(id)) {
        children.forEach(child => newSelectedColumns.add(child.id));
      }
    });
    this.setState({
      selectedColumns: newSelectedColumns
    });
  }

  /**
   * Removes a column or group from selected columns set.
   *
   * Removing a group will deselect all of its children.
   *
   * Removing a child will deselect all parent groups.
   * Other children in those parents will stay selected, just not the group item.
   *
   * @param name Name of the column to remove
   */
  removeColumnFromSelected(name) {
    var selectedColumns = this.state.selectedColumns;
    var flattenedItems = this.getFlattenedTree();
    var item = flattenedItems.find(_ref6 => {
      var id = _ref6.id;
      return id === name;
    });
    assertNotNull(item);
    var parentItem = flattenedItems.find(_ref7 => {
      var id = _ref7.id;
      return id === item.parentId;
    });

    // Remove all children of deselected groups
    flattenTree(item === null || item === void 0 ? void 0 : item.children).forEach(child => selectedColumns.delete(child.id));

    // Remove all parents of the removed group since it is no longer fully selected
    var _loop2 = function _loop2() {
      selectedColumns.delete(parentItem.id);
      var newParentId = parentItem.parentId;
      parentItem = flattenedItems.find(_ref8 => {
        var id = _ref8.id;
        return id === newParentId;
      });
    };
    while (parentItem != null) {
      _loop2();
    }
    selectedColumns.delete(name);
    this.setState({
      selectedColumns: new Set(selectedColumns)
    });
  }
  handleDragStart(id, event) {
    var selectedColumns = this.state.selectedColumns;
    if (selectedColumns.has(id)) {
      return;
    }
    var dragEvent = event.activatorEvent;
    var isAddingToSelection = GridUtils.isModifierKeyDown(dragEvent) || dragEvent.shiftKey;
    this.handleItemClick(id, event.activatorEvent, true);
    // Always add the dragged item back to selected in case the user ctrl+dragged on an already
    // selected item. The handleItemClick would deselect it, but we want to keep it selected.
    this.addColumnToSelected([id], isAddingToSelection);
  }
  handleDragEnd(from, to) {
    var _this$props7 = this.props,
      model = _this$props7.model,
      movedColumns = _this$props7.movedColumns,
      onMovedColumnsChanged = _this$props7.onMovedColumnsChanged,
      columnHeaderGroups = _this$props7.columnHeaderGroups,
      onColumnHeaderGroupChanged = _this$props7.onColumnHeaderGroupChanged;
    var selectedParentItems = this.getSelectedParentItems();
    var firstMovableIndex = this.getFirstMovableIndex();
    var lastMovableIndex = this.getLastMovableIndex();
    assertNotNull(firstMovableIndex);
    assertNotNull(lastMovableIndex);
    var _moveItemsFromDrop = moveItemsFromDrop(from, to, movedColumns, columnHeaderGroups, selectedParentItems, firstMovableIndex, lastMovableIndex),
      groupsAfterDrop = _moveItemsFromDrop.groups,
      newMoves = _moveItemsFromDrop.movedColumns;

    // Need to parse so the internal state is correct to prevent weird drop animations
    // when adding/removing from groups. But don't parse if nothing changed to prevent
    // unnecessary undo/redo states.
    var newGroups = groupsAfterDrop !== columnHeaderGroups ? IrisGridUtils.parseColumnHeaderGroups(model, groupsAfterDrop).groups : columnHeaderGroups;
    onColumnHeaderGroupChanged(newGroups);
    onMovedColumnsChanged(newMoves);
    // Without tracking the state here, React 18 is rendering the child separately from
    // the render which changes the prop. As a result, the drop animations go to the
    // original location because of that render with stale items. I could not find any
    // other way to fix this (removing memoization, removing keys, etc.)
    this.setState({
      movedColumns: newMoves,
      columnHeaderGroups: newGroups
    });
    // Focus the dragged item after the move. Should not scroll since it's already in view
    this.scrollAndFocusColumnOnUpdate = [to.index, from.id];
  }
  handleGroupNameChange(group, newName) {
    var _this$list3;
    var _this$props8 = this.props,
      columnHeaderGroups = _this$props8.columnHeaderGroups,
      onColumnHeaderGroupChanged = _this$props8.onColumnHeaderGroupChanged,
      endUndoGroup = _this$props8.endUndoGroup;
    var newGroups = [...columnHeaderGroups];
    var oldName = group.name;
    var groupIndex = newGroups.findIndex(_ref9 => {
      var name = _ref9.name;
      return name === oldName;
    });
    var oldGroup = newGroups[groupIndex];
    assertNotNull(oldGroup); // Also means groupIndex >= 0

    var newGroup = new ColumnHeaderGroup(oldGroup);
    newGroup.name = newName;
    newGroups.splice(groupIndex, 1, newGroup);
    var parentIndex = newGroups.findIndex(_ref0 => {
      var name = _ref0.name;
      return name === newGroup.parent;
    });
    if (parentIndex >= 0) {
      var newParent = new ColumnHeaderGroup(newGroups[parentIndex]);
      newParent.removeChildren([oldName]);
      newParent.addChildren([newName]);
      newGroups.splice(parentIndex, 1, newParent);
    }
    var oldElement = (_this$list3 = this.list) === null || _this$list3 === void 0 ? void 0 : _this$list3.querySelector(".item-wrapper[data-id=\"".concat(oldName, "\"]"));
    if (oldElement != null) {
      // The group will be a new item, so focus it after the update
      // otherwise we may lose focus entirely
      var indexAttr = oldElement.getAttribute('data-index');
      this.scrollAndFocusColumnOnUpdate = indexAttr != null ? [parseInt(indexAttr, 10), newName] : null;
    }
    onColumnHeaderGroupChanged(newGroups);
    endUndoGroup();
  }
  handleGroupDelete(group) {
    var _this$props9 = this.props,
      columnHeaderGroups = _this$props9.columnHeaderGroups,
      endUndoGroup = _this$props9.endUndoGroup,
      onColumnHeaderGroupChanged = _this$props9.onColumnHeaderGroupChanged;
    var newGroups = columnHeaderGroups.filter(g => g.name !== group.name);
    var parentIndex = newGroups.findIndex(g => g.name === group.parent);
    if (parentIndex >= 0) {
      var newParent = new ColumnHeaderGroup(newGroups[parentIndex]);
      newParent.addChildren(group.children);
      newParent.removeChildren([group.name]);
      newGroups.splice(parentIndex, 1, newParent);
    }
    onColumnHeaderGroupChanged(newGroups);
    // Could be started from editing a new group which is deleted without saving
    endUndoGroup();
  }
  handleGroupCreate() {
    var _this$props0 = this.props,
      movedColumns = _this$props0.movedColumns,
      onMovedColumnsChanged = _this$props0.onMovedColumnsChanged,
      onColumnHeaderGroupChanged = _this$props0.onColumnHeaderGroupChanged,
      startUndoGroup = _this$props0.startUndoGroup;
    var _this$moveSelectedCol2 = this.moveSelectedColumns(VisibilityOrderingBuilderInner.MOVE_OPTIONS.TOP),
      newMoves = _this$moveSelectedCol2.newMoves,
      groups = _this$moveSelectedCol2.groups;
    var newGroups = groups.filter(group => !group.isNew);
    var selectedItems = this.getSelectedParentItems();
    var childIndexes = selectedItems.map(item => item.data.modelIndex).flat().filter(index => index >= 0);

    // We don't care about this name really as long as it's unique
    // The user must change it and we display a placeholder instead
    var name = "".concat(ColumnHeaderGroup.NEW_GROUP_PREFIX, "-").concat(Date.now());
    var newGroup = new ColumnHeaderGroup({
      name,
      children: selectedItems.map(_ref1 => {
        var id = _ref1.id;
        return id;
      }),
      depth: 0,
      childIndexes: [...new Set(childIndexes)] // Remove any duplicates
    });
    startUndoGroup();
    onMovedColumnsChanged(movedColumns.concat(newMoves), () => {
      var _this$virtualizerRef$4;
      (_this$virtualizerRef$4 = this.virtualizerRef.current) === null || _this$virtualizerRef$4 === void 0 || (_this$virtualizerRef$4 = _this$virtualizerRef$4.scrollElement) === null || _this$virtualizerRef$4 === void 0 || _this$virtualizerRef$4.scrollTo({
        top: 0
      });
    });
    onColumnHeaderGroupChanged(newGroups.concat([newGroup]));
    this.resetSelection();
  }

  /**
   * Validates if a header group name is valid and not in use by any header groups or columns
   * @param groupName The name to validate
   * @returns Error message if invalid
   */
  validateGroupName(groupName) {
    var _this$props1 = this.props,
      model = _this$props1.model,
      columnHeaderGroups = _this$props1.columnHeaderGroups;
    var columns = model.columns;
    if (!DbNameValidator.isValidColumnName(groupName)) {
      return 'Invalid name';
    }
    if (columns.some(_ref10 => {
      var name = _ref10.name;
      return name === groupName;
    }) || columnHeaderGroups.some(_ref11 => {
      var name = _ref11.name;
      return name === groupName;
    })) {
      return 'Duplicate name';
    }
    return '';
  }
  renderItem(_ref12) {
    var value = _ref12.value,
      clone = _ref12.clone,
      item = _ref12.item,
      ref = _ref12.ref,
      handleProps = _ref12.handleProps;
    var onColumnVisibilityChanged = this.props.onColumnVisibilityChanged;
    var _this$state2 = this.state,
      selectedColumns = _this$state2.selectedColumns,
      showHiddenColumns = _this$state2.showHiddenColumns;
    var displayString = value;

    // The cloned drag overlay we want to show the items being dragged
    if (clone) {
      var selectedItemNames = this.getSelectedParentItems().map(_ref13 => {
        var id = _ref13.id;
        return id;
      });
      displayString = selectedItemNames.join(', ');
    }
    return /*#__PURE__*/_jsx(VisibilityOrderingItem, {
      ref: ref,
      value: displayString,
      clone: clone,
      item: item,
      childCount: selectedColumns.size,
      onVisibilityChange: onColumnVisibilityChanged,
      visibilityClickAndDrag: showHiddenColumns,
      onClick: this.handleItemClick,
      onGroupDelete: this.handleGroupDelete,
      onGroupColorChange: this.handleGroupColorChange,
      onGroupNameChange: this.handleGroupNameChange,
      validateGroupName: this.validateGroupName,
      handleProps: handleProps
    }, item.id);
  }
  /**
   * Gets the first movable visible index
   */
  getFirstMovableIndex() {
    var _this$props10 = this.props,
      model = _this$props10.model,
      movedColumns = _this$props10.movedColumns;
    return this.getMemoizedFirstMovableIndex(model, model.columns, movedColumns);
  }
  /**
   * Gets the last movable visible index
   */
  getLastMovableIndex() {
    var _this$props11 = this.props,
      model = _this$props11.model,
      movedColumns = _this$props11.movedColumns;
    return this.getMemoizedLastMovableIndex(model, model.columns, movedColumns);
  }
  /**
   * Gets the tree items in order. Memoized for efficiency
   * Use this.getFlattenedTree() if a flat list is needed
   * @param showHiddenColumns Whether to show hidden columns in the tree. Defaults to the current state value.
   * @returns The tree items in order
   */
  getTreeItems(showHiddenColumns) {
    var _this$props12 = this.props,
      model = _this$props12.model,
      hiddenColumns = _this$props12.hiddenColumns;
    var _this$state3 = this.state,
      movedColumns = _this$state3.movedColumns,
      columnHeaderGroups = _this$state3.columnHeaderGroups,
      selectedColumns = _this$state3.selectedColumns,
      showHiddenColumnsState = _this$state3.showHiddenColumns;
    return this.memoizedGetTreeItems(model.columns, movedColumns, columnHeaderGroups, hiddenColumns, selectedColumns, showHiddenColumns !== null && showHiddenColumns !== void 0 ? showHiddenColumns : showHiddenColumnsState);
  }
  /**
   * Gets the flattened tree items in order. Memoized for efficiency
   * @param showHiddenColumns Whether to show hidden columns in the tree. Defaults to the current state value.
   * @returns The flattened tree items in order
   */
  getFlattenedTree(showHiddenColumns) {
    return this.memoizedGetFlattenedTree(this.getTreeItems(showHiddenColumns));
  }
  getSelectedItemModelIndexes(columnNames) {
    var model = this.props.model;
    return [...columnNames.values()].map(name => model.getColumnIndexByName(name)).filter(i => i != null).flat();
  }

  /**
   * Gets the selected items that are movable.
   * This is any item whose parent is not also selected.
   *
   * @returns The array of items whose parents are not selected
   */
  getSelectedParentItems() {
    var selectedColumns = this.state.selectedColumns;
    var treeItems = this.getFlattenedTree();
    return treeItems.filter(_ref14 => {
      var id = _ref14.id,
        parentId = _ref14.parentId;
      return (
        // All items whose parents are not selected
        selectedColumns.has(id) && !selectedColumns.has(parentId !== null && parentId !== void 0 ? parentId : '')
      );
    });
  }
  handleOverflowAction(key) {
    var _this$props13 = this.props,
      undo = _this$props13.undo,
      redo = _this$props13.redo;
    switch (key) {
      case 'undo':
        undo();
        break;
      case 'redo':
        redo();
        break;
      case 'showHidden':
        this.setState(prev => ({
          showHiddenColumns: !prev.showHiddenColumns,
          selectedColumns: new Set()
        }));
        break;
    }
  }
  handleKeyboardShortcut(event) {
    var _this$props14 = this.props,
      canUndo = _this$props14.canUndo,
      canRedo = _this$props14.canRedo,
      undo = _this$props14.undo,
      redo = _this$props14.redo;
    if (GLOBAL_SHORTCUTS.UNDO.matchesEvent(event) && canUndo) {
      event.preventDefault();
      undo();
    } else if (GLOBAL_SHORTCUTS.REDO.matchesEvent(event) && canRedo) {
      event.preventDefault();
      redo();
    }
  }
  handleSearchModalOpenChange(isOpen) {
    if (isOpen) {
      this.resetSelection();
    } else {
      var _this$state4 = this.state,
        showHiddenColumns = _this$state4.showHiddenColumns,
        selectedColumns = _this$state4.selectedColumns;
      var onColumnVisibilityChanged = this.props.onColumnVisibilityChanged;
      // Make sure all selected columns are visible when closing the search modal
      if (!showHiddenColumns) {
        var modelIndexesToShow = this.getSelectedItemModelIndexes(selectedColumns);
        onColumnVisibilityChanged(modelIndexesToShow, true);
      }
    }
    this.setState({
      isSearchModalOpen: isOpen
    });
  }
  render() {
    var _this$props15 = this.props,
      model = _this$props15.model,
      hiddenColumns = _this$props15.hiddenColumns,
      onColumnVisibilityChanged = _this$props15.onColumnVisibilityChanged,
      canUndo = _this$props15.canUndo,
      canRedo = _this$props15.canRedo;
    var _this$state5 = this.state,
      selectedColumns = _this$state5.selectedColumns,
      showHiddenColumns = _this$state5.showHiddenColumns,
      isSearchModalOpen = _this$state5.isSearchModalOpen;
    var hasSelection = selectedColumns.size > 0;
    var flattenedItems = this.getFlattenedTree();
    var hiddenColumnsSet = new Set(hiddenColumns);
    var columnsToToggle = hasSelection ? this.getSelectedItemModelIndexes(selectedColumns) : model.columns.map((_, i) => i);
    var areSomeVisible = hasSelection ? columnsToToggle.some(column => !hiddenColumnsSet.has(column)) : hiddenColumnsSet.size < model.columns.length;
    var allToggleText = areSomeVisible ? 'Hide All' : 'Show All';
    var selectedToggleText = areSomeVisible ? 'Hide Selected' : 'Show Selected';
    var visibilityOrderingList = this.makeVisibilityOrderingList(model.columns, flattenedItems, showHiddenColumns, !isSearchModalOpen);
    return /*#__PURE__*/_jsx(SortableTreeDndContext, {
      items: flattenedItems,
      onDragStart: this.handleDragStart,
      onDragEnd: this.handleDragEnd,
      renderItem: this.renderItem,
      children: /*#__PURE__*/_jsxs("div", {
        role: "menu",
        ref: this.wrapperRef,
        className: "visibility-ordering-builder",
        tabIndex: 0,
        onKeyUp: this.handleKeyboardShortcut,
        children: [/*#__PURE__*/_jsxs("div", {
          className: "top-menu",
          children: [/*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            className: "toggle-visibility-btn",
            onClick: () => {
              onColumnVisibilityChanged(columnsToToggle, !areSomeVisible);
            },
            icon: areSomeVisible ? dhEye : dhEyeSlash,
            tooltip: "Toggle column visibility",
            children: !hasSelection ? allToggleText : selectedToggleText
          }), /*#__PURE__*/_jsx(SearchWithModal, {
            items: flattenedItems,
            onModalOpenChange: this.handleSearchModalOpenChange,
            onClick: this.handleSearchItemClicked,
            setSelection: this.handleSearchSelect
          }), /*#__PURE__*/_jsxs(MenuTrigger, {
            closeOnSelect: true,
            children: [/*#__PURE__*/_jsx(ActionButton, {
              isQuiet: true,
              "aria-label": "More options",
              children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: vsKebabVertical
              })
            }), /*#__PURE__*/_jsxs(SpectrumMenu, {
              onAction: this.handleOverflowAction,
              disabledKeys: [!canUndo && 'undo', !canRedo && 'redo'].filter(k => typeof k === 'string'),
              children: [/*#__PURE__*/_jsxs(Section, {
                "aria-label": "Undo and Redo",
                children: [/*#__PURE__*/_jsxs(Item, {
                  textValue: "Undo",
                  children: [/*#__PURE__*/_jsx(Icon, {
                    children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                      icon: vsBlank
                    })
                  }), /*#__PURE__*/_jsx(Text, {
                    children: "Undo"
                  }), /*#__PURE__*/_jsx(Keyboard, {
                    children: GLOBAL_SHORTCUTS.UNDO.getDisplayText()
                  })]
                }, "undo"), /*#__PURE__*/_jsxs(Item, {
                  textValue: "Redo",
                  children: [/*#__PURE__*/_jsx(Icon, {
                    children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                      icon: vsBlank
                    })
                  }), /*#__PURE__*/_jsx(Text, {
                    children: "Redo"
                  }), /*#__PURE__*/_jsx(Keyboard, {
                    children: GLOBAL_SHORTCUTS.REDO.getDisplayText()
                  })]
                }, "redo")]
              }), /*#__PURE__*/_jsx(Section, {
                "aria-label": "More actions",
                children: /*#__PURE__*/_jsxs(Item, {
                  textValue: "Show hidden columns",
                  children: [/*#__PURE__*/_jsx(Icon, {
                    children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                      icon: showHiddenColumns ? vsCheck : vsBlank
                    })
                  }), /*#__PURE__*/_jsx(Text, {
                    children: "Show hidden columns"
                  })]
                }, "showHidden")
              })]
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "top-menu",
          children: [/*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            icon: vsRefresh,
            className: "px-1",
            tooltip: "Reset to default",
            onClick: () => {
              this.resetVisibilityOrdering();
            },
            children: "Reset"
          }), /*#__PURE__*/_jsx("span", {
            className: "vertical-divider"
          }), /*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            icon: dhSortAlphaDown,
            className: "px-1",
            tooltip: "Sort ascending",
            onClick: () => {
              this.handleSortColumns(VisibilityOrderingBuilderInner.SORTING_OPTIONS.ASC);
            }
          }), /*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            icon: dhSortAlphaUp,
            className: "px-1",
            tooltip: "Sort descending",
            onClick: () => {
              this.handleSortColumns(VisibilityOrderingBuilderInner.SORTING_OPTIONS.DSC);
            }
          }), /*#__PURE__*/_jsx("span", {
            className: "vertical-divider"
          }), /*#__PURE__*/_jsxs(Button, {
            kind: "ghost",
            className: "px-1",
            tooltip: "Create group from selection",
            disabled: !hasSelection,
            onClick: this.handleGroupCreate,
            children: [/*#__PURE__*/_jsxs("span", {
              className: "fa-layers",
              children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                mask: vsSymbolStructure,
                icon: vsCircleLargeFilled,
                transform: "right-7 down-5 shrink-6"
              }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: vsAdd,
                transform: "right-8 down-6 shrink-8"
              })]
            }), "Group"]
          }), /*#__PURE__*/_jsx("span", {
            className: "vertical-divider"
          }), /*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            icon: vsChevronUp,
            className: "px-1",
            tooltip: "Move selection up",
            onClick: () => {
              this.handleMoveColumns(VisibilityOrderingBuilderInner.MOVE_OPTIONS.UP);
            },
            disabled: !hasSelection
          }), /*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            icon: vsChevronDown,
            className: "px-1",
            tooltip: "Move selection down",
            onClick: () => {
              this.handleMoveColumns(VisibilityOrderingBuilderInner.MOVE_OPTIONS.DOWN);
            },
            disabled: !hasSelection
          }), /*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            icon: dhArrowToTop,
            className: "px-1",
            tooltip: "Move selection to top",
            onClick: () => {
              this.handleMoveColumns(VisibilityOrderingBuilderInner.MOVE_OPTIONS.TOP);
            },
            disabled: !hasSelection
          }), /*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            icon: dhArrowToBottom,
            className: "px-1",
            tooltip: "Move selection to bottom",
            onClick: () => {
              this.handleMoveColumns(VisibilityOrderingBuilderInner.MOVE_OPTIONS.BOTTOM);
            },
            disabled: !hasSelection
          })]
        }), /*#__PURE__*/_jsx("div", {
          role: "menu",
          ref: list => {
            this.list = list;
          },
          className: classNames('visibility-ordering-list'),
          children: visibilityOrderingList
        })]
      })
    });
  }
}

// drag and drop display
_defineProperty(VisibilityOrderingBuilderInner, "SORTING_OPTIONS", {
  DSC: 'DSC',
  ASC: 'ASC'
});
_defineProperty(VisibilityOrderingBuilderInner, "MOVE_OPTIONS", {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
  UP: 'UP',
  DOWN: 'DOWN'
});
var VisibilityOrderingBuilder = /*#__PURE__*/memo(props => {
  var movedColumns = props.movedColumns,
    hiddenColumns = props.hiddenColumns,
    columnHeaderGroups = props.columnHeaderGroups,
    onMovedColumnsChanged = props.onMovedColumnsChanged,
    onColumnVisibilityChanged = props.onColumnVisibilityChanged,
    onColumnHeaderGroupChanged = props.onColumnHeaderGroupChanged,
    onFrozenColumnsChanged = props.onFrozenColumnsChanged,
    __testRef = props.__testRef;
  var _useUndoRedo = useUndoRedo({
      movedColumns,
      hiddenColumns,
      columnHeaderGroups,
      frozenColumns: props.model.frozenColumns
    }),
    setUndoState = _useUndoRedo.set,
    undo = _useUndoRedo.undo,
    canUndo = _useUndoRedo.canUndo,
    redo = _useUndoRedo.redo,
    canRedo = _useUndoRedo.canRedo,
    state = _useUndoRedo.state;

  // On undo/redo, we need to ignore the prop change
  // because we are the ones updating the props
  var isUndoRedoAction = useRef(false);
  var isBatched = useRef(false);
  var startUndoGroup = useCallback(() => {
    isBatched.current = true;
  }, []);
  var endUndoGroup = useCallback(() => {
    isBatched.current = false;
  }, []);
  useEffect(() => {
    if (isUndoRedoAction.current) {
      onMovedColumnsChanged(state.movedColumns);
      onColumnVisibilityChanged(hiddenColumns, true);
      onColumnVisibilityChanged(state.hiddenColumns, false);
      onColumnHeaderGroupChanged(state.columnHeaderGroups);
      onFrozenColumnsChanged(state.frozenColumns);
      isUndoRedoAction.current = false;
    } else if (
    // If the parent props changed and it's not an undo/redo action, update the undo state
    !isBatched.current && (movedColumns !== state.movedColumns || columnHeaderGroups !== state.columnHeaderGroups || hiddenColumns.length !== state.hiddenColumns.length || hiddenColumns.some((col, index) => col !== state.hiddenColumns[index]))) {
      setUndoState({
        movedColumns,
        hiddenColumns,
        columnHeaderGroups,
        frozenColumns: props.model.frozenColumns
      });
    }
  }, [columnHeaderGroups, hiddenColumns, isBatched, movedColumns, onColumnHeaderGroupChanged, onColumnVisibilityChanged, onFrozenColumnsChanged, onMovedColumnsChanged, props.model.frozenColumns, setUndoState, state.columnHeaderGroups, state.frozenColumns, state.hiddenColumns, state.movedColumns]);
  var handleColumnHeaderGroupChanged = useCallback(groups => {
    if (groups !== columnHeaderGroups) {
      onColumnHeaderGroupChanged(
      // Updates which model indexes are in the groups if items were added/removed
      IrisGridUtils.parseColumnHeaderGroups(props.model, groups).groups);
    }
  }, [columnHeaderGroups, onColumnHeaderGroupChanged, props.model]);
  var handleUndo = useCallback(() => {
    isUndoRedoAction.current = true;
    undo();
  }, [undo]);
  var handleRedo = useCallback(() => {
    isUndoRedoAction.current = true;
    redo();
  }, [redo]);
  return /*#__PURE__*/_jsx(VisibilityOrderingBuilderInner
  // eslint-disable-next-line react/jsx-props-no-spreading
  , _objectSpread(_objectSpread({}, props), {}, {
    ref: __testRef,
    movedColumns: movedColumns,
    hiddenColumns: hiddenColumns,
    columnHeaderGroups: columnHeaderGroups,
    onMovedColumnsChanged: onMovedColumnsChanged,
    onColumnVisibilityChanged: onColumnVisibilityChanged,
    onColumnHeaderGroupChanged: handleColumnHeaderGroupChanged,
    undo: handleUndo,
    canUndo: canUndo,
    redo: handleRedo,
    canRedo: canRedo,
    startUndoGroup: startUndoGroup,
    endUndoGroup: endUndoGroup
  }));
});
VisibilityOrderingBuilder.displayName = 'VisibilityOrderingBuilder';
export default VisibilityOrderingBuilder;
//# sourceMappingURL=VisibilityOrderingBuilder.js.map